var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0360D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4652_44619",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4652_44619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.723 16.8385L10.7654 22.7231C10.4641 22.8436 10.1779 22.8176 9.90675 22.6452C9.63558 22.4727 9.5 22.2224 9.5 21.8942V10.1059C9.5 9.77764 9.63558 9.52731 9.90675 9.35488C10.1779 9.18245 10.4641 9.15649 10.7654 9.27701L24.723 15.1616C25.0948 15.3257 25.2806 15.6052 25.2806 16C25.2806 16.3949 25.0948 16.6744 24.723 16.8385ZM11 21L22.85 16L11 11V14.6924L16.423 16L11 17.3077V21Z",
    fill: "#E6F4FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendComment);
export default __webpack_public_path__ + "static/media/sendComment.c8e64da05a28c3d384e3a327299bfe0c.svg";
export { ForwardRef as ReactComponent };